export default __webpack_public_path__ + "static/media/homebanner.bce5bbe3.jpg";